let language = {
    300401: "Resource catalog does not exist",
}

export { language }